import React, {Component} from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import './styles.scss';

class SelectComponent extends Component {

    render() {
        return (
            <FormControl className={"form-control-nav"}>
                <label className={"label"}>{this.props.label}</label>
                <Select
                    displayEmpty
                    className={"select-nav"}
                    disableUnderline={true}
                    disabled={this.props.disabled}
                    value={this.props.selectedValue}
                    onChange={this.props.onValueChange}
                >
                    <MenuItem value={-1}>{this.props.defaultValue}</MenuItem>
                    {this.props.values.map((val) =>{
                        return (<MenuItem key={val.id} value={val.id}>
                            {val.name}
                        </MenuItem>);
                    })}
                </Select>
            </FormControl>
        );
    }
}

export default SelectComponent;


// WEBPACK FOOTER //
// ./src/containers/general/header/select/SelectNavigation.js